<div class="law-sample-management-container">
  <!-- 頁面標題 -->
  <div class="page-header">
    <h2>法規樣本管理</h2>
    <p class="page-description">管理 law_sample 容器中的法規樣本資料</p>
  </div>

  <!-- 搜尋和操作區域 -->
  <div class="controls-section">
    <div class="left-controls">
      <div class="filter-controls">
        <div class="filter-group">
          <label for="topicFilter">主題篩選：</label>
          <select
            id="topicFilter"
            class="form-control topic-filter"
            [(ngModel)]="selectedTopic"
            (change)="onTopicChange()"
          >
            <option value="">全部主題</option>
            <option *ngFor="let topic of topicOptions" [value]="topic">{{ topic }}</option>
          </select>
        </div>
      </div>
      
      <div class="search-controls">
        <div class="search-group">
          <input
            type="text"
            class="form-control search-input"
            placeholder="搜尋法規名稱、主題、類型或位階..."
            [(ngModel)]="searchKeyword"
            (input)="onSearch()"
          >
          <i class="fa-solid fa-search search-icon"></i>
        </div>
      </div>
    </div>
    
    <div class="action-controls">
      <button class="btn btn-primary add-btn" (click)="openAddModal()">
        <i class="fa-solid fa-plus"></i>
        新增法規樣本
      </button>
    </div>
  </div>

  <!-- 載入指示器 -->
  <div *ngIf="isLoading" class="loading-spinner">
    <i class="fa-solid fa-spinner fa-spin"></i>
    <span>載入中...</span>
  </div>

  <!-- 法規樣本表格 -->
  <div *ngIf="!isLoading" class="table-container">
    <div *ngIf="filteredLawSamples.length === 0 && searchKeyword" class="no-results">
      <i class="fa-solid fa-search"></i>
      <p>找不到符合「{{ searchKeyword }}」的法規樣本</p>
    </div>

    <div *ngIf="filteredLawSamples.length === 0 && !searchKeyword" class="no-data">
      <i class="fa-solid fa-file-lines"></i>
      <p>目前沒有法規樣本資料</p>
      <button class="btn btn-primary" (click)="openAddModal()">
        <i class="fa-solid fa-plus"></i>
        新增第一筆法規樣本
      </button>
    </div>

    <table *ngIf="filteredLawSamples.length > 0" class="table table-responsive">
      <thead>
        <tr>
          <th>主題</th>
          <th>類型</th>
          <th>法規名稱</th>
          <th>位階</th>
          <th>法規網址</th>
          <th class="actions-column">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let lawSample of filteredLawSamples">
          <td>{{ lawSample.topic }}</td>
          <td>{{ lawSample.type }}</td>
          <td class="law-name">{{ lawSample.law_name }}</td>
          <td>{{ lawSample.law_hierarchy }}</td>
          <td class="url-column">
            <a [href]="lawSample.law_url" target="_blank" rel="noopener noreferrer" class="law-url">
              {{ lawSample.law_url | slice:0:50 }}{{ lawSample.law_url.length > 50 ? '...' : '' }}
            </a>
          </td>
          <td class="actions-column">
            <button
              class="btn btn-sm btn-outline-secondary edit-btn"
              (click)="openEditModal(lawSample)"
              title="編輯">
              <i class="fa-solid fa-edit"></i>
            </button>
            <button
              class="btn btn-sm btn-outline-danger delete-btn"
              (click)="deleteLawSampleConfirm(lawSample)"
              title="刪除">
              <i class="fa-solid fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- 新增/編輯模態框 -->
<div *ngIf="isModalOpen" class="modal-backdrop" (click)="closeModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">
          <i class="fa-solid" [ngClass]="isEditMode ? 'fa-edit' : 'fa-plus'"></i>
          {{ isEditMode ? '編輯法規樣本' : '新增法規樣本' }}
        </h4>
        <button type="button" class="close-btn" (click)="closeModal()">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>

      <div class="modal-body">
        <form>
          <!-- 主題 -->
          <div class="form-group">
            <label for="topic">主題 <span class="required">*</span></label>
            <input
              type="text"
              id="topic"
              class="form-control"
              [(ngModel)]="formData.topic"
              [class.is-invalid]="formErrors['topic']"
              name="topic"
              placeholder="請輸入主題，例如：ISO 45001"
            >
            <div *ngIf="formErrors['topic']" class="invalid-feedback">
              {{ formErrors['topic'] }}
            </div>
          </div>

          <!-- 類型 -->
          <div class="form-group">
            <label for="type">類型 <span class="required">*</span></label>
            <input
              type="text"
              id="type"
              class="form-control"
              [(ngModel)]="formData.type"
              [class.is-invalid]="formErrors['type']"
              name="type"
              placeholder="請輸入類型，例如：消防目"
            >
            <div *ngIf="formErrors['type']" class="invalid-feedback">
              {{ formErrors['type'] }}
            </div>
          </div>

          <!-- 法規名稱 -->
          <div class="form-group">
            <label for="law_name">法規名稱 <span class="required">*</span></label>
            <input
              type="text"
              id="law_name"
              class="form-control"
              [(ngModel)]="formData.law_name"
              [class.is-invalid]="formErrors['law_name']"
              name="law_name"
              placeholder="請輸入法規名稱"
            >
            <div *ngIf="formErrors['law_name']" class="invalid-feedback">
              {{ formErrors['law_name'] }}
            </div>
          </div>

          <!-- 法規位階 -->
          <div class="form-group">
            <label for="law_hierarchy">法規位階 <span class="required">*</span></label>
            <select
              id="law_hierarchy"
              class="form-control"
              [(ngModel)]="formData.law_hierarchy"
              [class.is-invalid]="formErrors['law_hierarchy']"
              name="law_hierarchy"
            >
              <option value="">請選擇法規位階</option>
              <option *ngFor="let option of hierarchyOptions" [value]="option">{{ option }}</option>
            </select>
            <div *ngIf="formErrors['law_hierarchy']" class="invalid-feedback">
              {{ formErrors['law_hierarchy'] }}
            </div>
          </div>

          <!-- 法規網址 -->
          <div class="form-group">
            <label for="law_url">法規網址 <span class="required">*</span></label>
            <input
              type="url"
              id="law_url"
              class="form-control"
              [(ngModel)]="formData.law_url"
              [class.is-invalid]="formErrors['law_url']"
              name="law_url"
              placeholder="請輸入完整的法規網址，例如：https://..."
            >
            <div *ngIf="formErrors['law_url']" class="invalid-feedback">
              {{ formErrors['law_url'] }}
            </div>
          </div>

          <!-- 公司 ID（唯讀） -->
          <!-- <div class="form-group">
            <label for="companyid">公司 ID</label>
            <input
              type="text"
              id="companyid"
              class="form-control"
              [value]="formData.companyid"
              readonly
              name="companyid"
            >
            <small class="form-text text-muted">此欄位自動填入，無法修改</small>
          </div> -->
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
          <i class="fa-solid fa-times"></i>
          取消
        </button>
        <button type="button" class="btn btn-primary" (click)="saveLawSample()" [disabled]="isLoading">
          <i class="fa-solid" [ngClass]="isLoading ? 'fa-spinner fa-spin' : (isEditMode ? 'fa-save' : 'fa-plus')"></i>
          {{ isEditMode ? '更新' : '新增' }}
        </button>
      </div>
    </div>
  </div>
</div>
